export default "__VITE_ASSET__a3fe7b35__"